import { render, staticRenderFns } from "./ProfileMisFavoritos.vue?vue&type=template&id=dc933d8a&"
import script from "./ProfileMisFavoritos.vue?vue&type=script&lang=js&"
export * from "./ProfileMisFavoritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports